'use strict';

var angular = require('angular');
var _ = require('lodash');
var profileLevels = {
  'MQ_SPOS': 3,
  'MQ_SPOS_DOWG': 2,
  'MQ_SPOS_S': 1,
  'MQ_SPOS_S_DOWG': 0
};
module.exports = angular.module('AVRO.DemandTransparency.Constants', []).constant('DemandTransparencyConstants', {
  DATA_DIMENSION: {
    MAPPED: 'mapped',
    REGULAR: 'regular'
  },
  VIEW: {
    FORECAST_PROFILE: 'forecast-profile',
    DTD_MATRIX: 'dtd-matrix',
    ALL_DATA: 'all-data',
    FORECAST_DATA: 'forecast-data'
  },
  PROFILE_LEVELS: profileLevels,
  INVERTED_PROFILE_LEVELS: _.invert(profileLevels),
  PROFILE_LEVEL_MAPPING: {
    'MQ_SPOS': 'All Data',
    'MQ_SPOS_S': 'Season',
    'MQ_SPOS_DOWG': 'DOW Group',
    'MQ_SPOS_S_DOWG': 'Season-DOW Group'
  },
  METRICS: [{
    fullMetric: 'Total Bookings',
    shorthand: 'Total Bkgs'
  }, {
    fullMetric: 'Grp Bookings',
    shorthand: 'Grp Bkgs'
  }, {
    fullMetric: 'Idv Bookings',
    shorthand: 'Idv Bkgs'
  }, {
    fullMetric: 'Untruncated Bookings',
    shorthand: 'Untruncated Bkgs'
  }, {
    fullMetric: 'Remaining Demand',
    shorthand: 'Remaining Demand'
  }]
});